
import { computed } from "vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";

export default {
  setup() {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const eventData = computed(() => {
      return store.getters["user/eventData"];
    });

    function goTo(to) {
      router.push({ name: to, query: { eventID: route.params.eventID } });
    }
    function cutString(text, number) {
      var cut = text.indexOf(" ", number);
      if (cut == -1) return text;
      return text.substring(0, cut);
    }

    return {
      eventData,
      goTo,
      cutString,
    };
  },
};
